import React, { useEffect, useState, useCallback } from "react"
import config, { getBasicAuthHeaders } from "utils/configAdapter"
import { connect } from "react-redux"
import * as Icons from "@ant-design/icons"
import BreadcrumbAdapter from "components/adapters/BreadcrumbAdapter"
import { getColumnSearchProps } from "utils/helpers"
import dayjs from 'dayjs'
import 'dayjs/locale/pt-br'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import {
    Space,
    Row,
    Col,
    Form,
    Input,
    Table,
    Button,
    Select,
    message,
    Divider,
    Typography,
    DatePicker,
    Spin,
    Card,
} from "antd"
import ptBR from 'antd/es/date-picker/locale/pt_BR'

dayjs.extend(customParseFormat)
dayjs.locale('pt-br')

// Removed: const _initToken = localStorage.getItem("authUser")

const Adicionais = props => {
    const { Title, Text } = Typography

    const { RangePicker } = DatePicker
    const [loading, setLoading] = useState(false)
    const [dataSource, setDataSource] = useState([])
    const [dataTotal, setDataTotal] = useState([])
    const [dataTotalAdic, setDataTotalAdic] = useState([])
    const [adic, setAdic] = useState([])
    const [aderiu, setAderiu] = useState("sim")
    const [loadingExcel, setLoadingExcel] = useState(false)
    const [segmentos, setSegmentos] = useState([])

    const [paramsEXCEL, setParamsEXCEL] = useState("")

    const [form] = Form.useForm()
    const FormItem = Form.Item
    const { Option } = Select

    const callSegmentos = useCallback(async () => {
        try {
            let response = await fetch(
                config[process.env.NODE_ENV].url +
                    "/relatorio/empresa/segmento",
                {
                    method: "POST",
                    headers: new Headers({
                        ...getBasicAuthHeaders(),
                        "Content-Type": "application/json",
                    }),
                }
            )
            response = await response.json()

            response = response.content.map(v => {
                return {
                    label: v.seat_ds_descricao,
                    value: v.seat_cd_nseq,
                }
            })

            setSegmentos(response)
        } catch (e) {}
    })

    useEffect(() => {
        callSegmentos()
        inicialDates()

        if (window.location.search) {
            let URLparams = {}
            window.location.search
                .replace("?", "")
                .split("&")
                .map(e => {
                    e = e.split("=")
                    Object.assign(URLparams, { [e[0]]: e[1] })
                })
            if (URLparams.adic) {
                URLparams.blto_adic = URLparams.adic
            }
            if (URLparams.s) {
                URLparams.empresa_pesquisa = URLparams.s
            }
            if (URLparams.t) {
                //parametros das tabs
            } else {
                let params = { tipo: "sim", /*default*/ ...URLparams }
                form.setFieldsValue(params)
                if (Object.keys(URLparams).length) callSearchForm(params)
            }
        }
    }, [])

    const inicialDates = () => {
        let d = new Date()
        let dini = new Date(d.getFullYear(), d.getMonth(), 1)
        let dfim = new Date(dini.getFullYear(), dini.getMonth() + 1, 0)
        let params = {
            date: [dayjs(dini), dayjs(dfim)],
        }
        form.setFieldsValue(params)
    }

    const groupResumoEntidade = arr => {
        let obj = {}

        for (let i = 0; i < arr.length; i++) {
            if (obj[arr[i].entidade_sigla] === undefined) {
                obj[arr[i].entidade_sigla] = {
                    lista: [],
                    sumario: {},
                }
            }

            obj[arr[i].entidade_sigla].lista.push(arr[i])
        }

        Object.keys(obj).map(key => {
            let sumario = {
                sumario: true,
                qtd_blto_enti: 0,
                total_blto_enti: 0,
                total_adic_enti: 0,
            }

            obj[key].lista.map(vl => {
                sumario.qtd_blto_enti += vl.relatorio.qtd_blto
                sumario.total_blto_enti += vl.relatorio.sum_blto_pgo
                sumario.total_adic_enti += vl.relatorio.sum_adic
            })

            obj[key].sumario = sumario
        })

        return obj
    }

    const callSearchForm = async data => {
        try {
            let params = JSON.parse(JSON.stringify(data)) //clear null

            if (!params.date) {
                throw Error("Informe a data inicial e final")
            }

            params.dataIni = dayjs(
                params.date[0] ? params.date[0] : null
            ).format("YYYY-MM-DD")
            params.dataFim = dayjs(
                params.date[1] ? params.date[1] : null
            ).format("YYYY-MM-DD")
            delete params.date

            let searchParams = new URLSearchParams(params)
            searchParams = searchParams.toString()
            setParamsEXCEL(searchParams)

            setLoading(true)

            let result = await fetch(
                config[process.env.NODE_ENV].url +
                    `/adicionais/relatorios/agrupamento-pagamentos?${searchParams}`,
                {
                    method: "GET",
                    headers: getBasicAuthHeaders(),
                }
            )

            if (!result.ok) {
                throw await result.json()
            }

            result = await result.json()

            result = groupResumoEntidade(result.content)
            setDataSource(result)
        } catch (e) {
            //mensagem de erro
            if (e.hasOwnProperty("message")) {
                message.error(e.message)
            } else {
                message.error("Erro em executar a chamada.")
            }
        } finally {
            setLoading(false)
        }
    }

    const downloadExcelBlob = async url => {
        try {
            setLoadingExcel(true)
            let resp = await fetch(url, {
                method: "GET",
                headers: getBasicAuthHeaders(),
            })

            resp = await resp.blob()

            if (!resp.message) {
                setLoadingExcel(false)
                let url = window.URL.createObjectURL(resp)
                let a = document.createElement("a")
                a.href = encodeURI(url)
                a.download = "RELATORIO_ADIC_AGRUP.xlsx"
                document.body.appendChild(a) // we need to append the element to the dom -> otherwise it will not work in firefox
                a.click()
                a.remove()
            } else {
                setLoadingExcel(false)
                message.error(resp.message)
            }
        } catch (e) {
            setLoadingExcel(false)
            message.error("Erro na chamada de arquivo")
        }
    }

    const formSearch = () => {
        return (
            <Form layout="vertical" form={form} onFinish={callSearchForm}>
                <Row gutter={5}>
                    {/* ROW */}

                    <Col sm={24} md={6} lg={6}>
                        <FormItem name="date" label="Data">
                            <RangePicker
                                locale={ptBR}
                                disabledDate={current => {
                                    return (
                                        current &&
                                        current > dayjs().endOf("day")
                                    )
                                }}
                                style={{ width: "100%" }}
                                showToday={true}
                                format="DD/MM/YYYY"
                            />
                        </FormItem>
                    </Col>

                    {/* <Col sm={24} md={6} lg={6}>
                            <FormItem
                                name="segmento"
                                label="Segmento"
                            >
                                <Select 
                                    options={segmentos}
                                />
                            </FormItem>
                        </Col> */}

                    <Col sm={24} md={5} lg={5}>
                        <FormItem name="entidade" label="Entidade: CNPJ/SIGLA">
                            <Input />
                        </FormItem>
                    </Col>

                    {/* ROW */}

                    <Col sm={24} md={7} lg={7} align="right">
                        <div style={{ marginTop: 55, display: "inline-block" }}>
                            {paramsEXCEL ? (
                                <a
                                    style={{ paddingRight: "10px" }}
                                    href={"#"}
                                    onClick={() =>
                                        downloadExcelBlob(
                                            `${
                                                config[process.env.NODE_ENV].url
                                            }/adicionais/relatorios/agrupamento-pagamentos?${paramsEXCEL}&excel=true`
                                        )
                                    }
                                >
                                    <Button
                                        disabled={loadingExcel}
                                        loading={loadingExcel}
                                        type="button'"
                                    >
                                        Download XLSX
                                    </Button>
                                </a>
                            ) : (
                                ""
                            )}
                            <Button disabled={loadingExcel} htmlType={"submit"}>
                                Gerar Relatório
                            </Button>
                            <Button
                                type="ghost"
                                disabled={loadingExcel}
                                onClick={() => {
                                    setDataSource([])
                                    form.resetFields()
                                }}
                            >
                                Limpar Relatório
                            </Button>
                        </div>
                    </Col>
                </Row>
            </Form>
        )
    }

    const [pageSize, setPageSize] = useState(1000)
    let columnsBase = [
        {
            title: <small>ENTIDADE</small>,
            dataIndex: "entidade_sigla",
            key: "entidade_sigla",
            width: 155,
        },
        {
            title: <small>ADICIONAL</small>,
            dataIndex: "nome_adic",
            ...getColumnSearchProps("nome_adic"),
            sorter: (a, b) =>
                a.nome_adic.trim().localeCompare(b.nome_adic.trim()),
            key: "nome_adic",
        },
        {
            title: (
                <small>
                    QTD
                    <br />
                    BOLETOS.
                </small>
            ),
            key: "qtd_boleto",
            width: 100,
            render: (data, row) => {
                return data.relatorio.qtd_blto ? data.relatorio.qtd_blto : "-"
            },
        },
        {
            title: (
                <small>
                    TOTAL
                    <br />
                    BOLETOS
                </small>
            ),
            key: "ttl_boletos",
            width: 155,
            render: (data, row) => {
                return data.relatorio.sum_blto_pgo
                    ? new Intl.NumberFormat("pt-BR", {
                          style: "currency",
                          currency: "BRL",
                      }).format(data.relatorio.sum_blto_pgo)
                    : "-"
            },
        },
        {
            title: (
                <small>
                    TOTAL
                    <br />
                    ADICIONAL
                </small>
            ),
            key: "ttl_boletos",
            width: 155,
            render: (data, row) => {
                return data.relatorio.sum_adic
                    ? new Intl.NumberFormat("pt-BR", {
                          style: "currency",
                          currency: "BRL",
                      }).format(data.relatorio.sum_adic)
                    : "-"
            },
        },
    ]
    const [columns, setColumns] = useState(columnsBase)
    const tableContent = () => {
        return (
            <Row>
                <Col sm={24} md={24} lg={24}>
                    {Object.keys(dataSource).map(source => {
                        console.log("source >", source)
                        return (
                            <div key={source + "table_loop"}>
                                {source.length ? (
                                    <Divider orientation="left">
                                        {source}
                                    </Divider>
                                ) : null}
                                <Table
                                    rowKey={"id_adic"}
                                    columns={columns}
                                    scroll={{ x: 400 }}
                                    dataSource={dataSource[source].lista}
                                    pagination={{
                                        hideOnSinglePage: true,
                                        // showTotal:() => <span>Total <b>{dataSource.length}</b> empregadores</span>,
                                        pageSize: pageSize,
                                        // pageSizeOptions:[20,50,100],
                                        // onShowSizeChange:(current, pageSize) => {
                                        //     // console.log(current, pageSize);
                                        //     setPageSize(pageSize)
                                        // }
                                    }}
                                    summary={pageData => {
                                        let sumario = dataSource[source].sumario
                                        return (
                                            <>
                                                <Table.Summary.Row>
                                                    <Table.Summary.Cell
                                                        index={0}
                                                    >
                                                        RESUMO
                                                    </Table.Summary.Cell>
                                                    <Table.Summary.Cell
                                                        index={1}
                                                    >
                                                        {" "}
                                                    </Table.Summary.Cell>
                                                    <Table.Summary.Cell
                                                        index={2}
                                                    >
                                                        <Text>
                                                            {
                                                                sumario.qtd_blto_enti
                                                            }
                                                        </Text>
                                                    </Table.Summary.Cell>
                                                    <Table.Summary.Cell
                                                        index={3}
                                                    >
                                                        <Text>
                                                            {new Intl.NumberFormat(
                                                                "pt-BR",
                                                                {
                                                                    style:
                                                                        "currency",
                                                                    currency:
                                                                        "BRL",
                                                                }
                                                            ).format(
                                                                sumario.total_blto_enti
                                                            )}
                                                        </Text>
                                                    </Table.Summary.Cell>
                                                    <Table.Summary.Cell
                                                        index={4}
                                                    >
                                                        <Text>
                                                            {new Intl.NumberFormat(
                                                                "pt-BR",
                                                                {
                                                                    style:
                                                                        "currency",
                                                                    currency:
                                                                        "BRL",
                                                                }
                                                            ).format(
                                                                sumario.total_adic_enti
                                                            )}
                                                        </Text>
                                                    </Table.Summary.Cell>
                                                </Table.Summary.Row>
                                            </>
                                        )
                                    }}
                                />
                                <br />
                            </div>
                        )
                    })}
                </Col>
            </Row>
        )
    }

    return (
        <>
            <Row>
                <Col span={24}>
                    <BreadcrumbAdapter
                        data={[
                            { titulo: "Adicionais", link: "/" },
                            { titulo: "Relatório Pagamentos" },
                        ]}
                    />
                </Col>
            </Row>

            {/* Header Section */}
            <Card
                style={{ marginBottom: 24 }}
                bodyStyle={{ padding: "20px 24px" }}
            >
                <Row align="middle" justify="space-between">
                    <Col>
                        <Title
                            level={2}
                            style={{ margin: 0, color: "#1890ff" }}
                        >
                            <Icons.FileExcelOutlined style={{ marginRight: 8 }} />
                            Relatório de Pagamentos
                        </Title>
                        <Text type="secondary" style={{ fontSize: "14px" }}>
                            Relatório consolidado por entidade e adicional, mostrando agrupamentos de pagamentos e valores totalizados em formato Excel.
                        </Text>
                    </Col>
                </Row>
            </Card>

            <Spin spinning={loading}>
                {formSearch()}

                <Divider />

                {loading ? <></> : tableContent()}
            </Spin>
        </>
    )
}

const mapStateToProps = state => {
    return {
        user: state.user,
    }
}

export default connect(mapStateToProps)(Adicionais)
